var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row bg-grey pt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "title-h3 border-bottom pb-3" }, [
            _c("button", {
              staticClass: "btn btn-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/trucks")
                }
              }
            }),
            _vm._v("\n        Back\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            },
            keydown: function($event) {
              _vm.clearError($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "l-bg-white" },
            [
              _c("div", { staticClass: "row my-4" }, [
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Truck name")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.name,
                            expression: "truck.name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.truck, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "name" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Licence plate")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.licence_plate,
                            expression: "truck.licence_plate"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.licence_plate },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.truck,
                              "licence_plate",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "licence_plate" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Size")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.truck_sizes,
                            placeholder: "Select Size"
                          },
                          model: {
                            value: _vm.truck.truck_size_id,
                            callback: function($$v) {
                              _vm.$set(_vm.truck, "truck_size_id", $$v)
                            },
                            expression: "truck.truck_size_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "truck_size_id" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Seats")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.number_of_seats,
                            expression: "truck.number_of_seats"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.number_of_seats },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.truck,
                              "number_of_seats",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "number_of_seats" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-4" }, [
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Carrier")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.carriers,
                            placeholder: "Select Carrier"
                          },
                          model: {
                            value: _vm.truck.carrier_id,
                            callback: function($$v) {
                              _vm.$set(_vm.truck, "carrier_id", $$v)
                            },
                            expression: "truck.carrier_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "carrier" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Status")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.truckStatuses,
                            placeholder: "Select Carrier"
                          },
                          model: {
                            value: _vm.truck.status_id,
                            callback: function($$v) {
                              _vm.$set(_vm.truck, "status_id", $$v)
                            },
                            expression: "truck.status_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "status_id" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-4" }, [
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Make")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.make,
                            expression: "truck.make"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.make },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.truck, "make", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "make" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Model")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.model,
                            expression: "truck.model"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.model },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.truck, "model", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "model" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Year")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.year,
                            expression: "truck.year"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.year },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.truck, "year", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "year" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Zip")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.truck.zip,
                            expression: "truck.zip"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.truck.zip },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.truck, "zip", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "zip" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("FilesUpload", {
                attrs: {
                  sources: _vm.truck.images,
                  model: "trucks",
                  "model-id": parseInt(_vm.$route.params.id)
                },
                on: { update: _vm.getTruck }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0" }, [
                _c("div", { staticClass: "col py-2 px-0 text-right" }, [
                  _vm.$_can("carriers.trucks.destroy")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-delete float-left",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.remove({
                                carrierId: _vm.carrier,
                                truckId: _vm.truck.id
                              })
                            }
                          }
                        },
                        [_vm._v("\n            Delete\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.getTruck }
                    },
                    [_vm._v("\n            Discard\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.$_can("carriers.trucks.update")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: { disabled: _vm.buttonDisabled }
                        },
                        [
                          _vm._v("\n            Save\n            "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("trucks-calendar")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11d99e4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d99e4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trucks/TrucksEdit.vue
// module id = null
// module chunks = 